import React from 'react';
import PropTypes from 'prop-types';
import { HISTORY_LABELS, historyByGame } from '../../../shared/playtest';
import { displayOf } from './playtestDisplay';

const SPACING = { section: 12, row: 4 };

const styles = {
  panel: { display: 'flex', flexDirection: 'column', gap: SPACING.section },
  game: { display: 'flex', flexDirection: 'column', gap: SPACING.row },
  entry: { display: 'flex', gap: SPACING.row },
};

/** Draw and opening history, grouped by game with the newest game last. */
const HistoryPanel = ({ session }) => {
  const state = session.engine;
  const games = historyByGame(state);

  return (
    <section data-testid="history-panel" style={styles.panel}>
      <h4>History</h4>
      {games.map(({ game, entries }) => (
        <div key={game} data-testid={`history-game-${game}`} style={styles.game}>
          <strong>{`Game ${game}`}</strong>
          {entries.map((entry) => {
            const view = displayOf(session, state.instances[entry.instanceId].cardId);
            return (
              <div key={entry.seq} data-testid={`history-entry-${entry.seq}`} style={styles.entry}>
                <span>{view.name}</span>
                <span>{HISTORY_LABELS[entry.source]}</span>
              </div>
            );
          })}
        </div>
      ))}
    </section>
  );
};

HistoryPanel.propTypes = {
  session: PropTypes.shape({
    engine: PropTypes.object.isRequired,
    cardViews: PropTypes.instanceOf(Map).isRequired,
  }).isRequired,
};

export default HistoryPanel;
